import React, { useState, useRef, useEffect } from "react";

interface Category {
    id: number;
    title: string;
}

interface MultiSelectProps {
    value: number[];
    onChange: (value: number[]) => void;
    categories: Category[];
}

const MultiSelect: React.FC<MultiSelectProps> = ({ value, onChange, categories }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleOption = (id: number) => {
        if (value.includes(id)) {
            onChange(value.filter(v => v !== id));
        } else {
            onChange([...value, id]);
        }
    };

    // Закрываем при клике вне меню
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedText =
        value.length === 0 ? "Виберіть категорії..." :
            value.length === 1 ? categories.find(c => c.id === value[0])?.title :
                `Обрано: ${value.length}`;

    return (
        <div className="relative w-60" ref={dropdownRef}>
            <div
                className="border border-gray-300 rounded-md px-3 py-2 bg-white text-blue-800 cursor-pointer select-none
                           flex justify-between items-center hover:border-blue-400"
                onClick={() => setOpen(!open)}
            >
                <span className={value.length === 0 ? "text-gray-400" : ""}>{selectedText}</span>
                <span className="text-gray-500">▾</span>
            </div>

            {open && (
                <div
                    className="absolute mt-1 w-full bg-white shadow-lg rounded-md border border-gray-200 max-h-48 overflow-y-auto z-20 custom-scrollbar"
                >
                    {categories.map(cat => (
                        <label
                            key={cat.id}
                            className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-blue-50"
                        >
                            <input
                                type="checkbox"
                                checked={value.includes(cat.id)}
                                onChange={() => toggleOption(cat.id)}
                                className="cursor-pointer"
                            />
                            <span>{cat.title}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiSelect;
